<script lang="ts" setup>
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import type {Automation} from "~/models/Automation";

const open = ref<boolean>(false);

defineProps<{
    created?: (automation: Automation) => void | Promise<void>;
}>()
</script>

<template>
    <UButton
        id="new-automation-btn"
        color="hd-primary"
        size="md"
        class="px-4 py-3"
        @click="open = !open"
    >
        <template #leading>
            <FontAwesomeIcon :icon="faPlus" size="lg" />
        </template>
        <span>New Automation</span>
    </UButton>
    <CreateAutomationWithTemplates v-model:open="open" :created="created" />
</template>
